import { z } from "zod";

import { queryClient } from "@App";
import { i18n } from "@lib/i18n";
import { queries } from "@lib/queries";
import { globalLayoutRoute } from "@routes";
import { allowAdminAndUser, requireScope } from "@routes/authorization";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

const JobDescriptionsSearchSchema = z.object({
    jdid: z.string().optional(),
});
type JobDescriptionsSearch = z.infer<typeof JobDescriptionsSearchSchema>;
export const jobDescriptionsRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `job-descriptions`,
    component: lazyRouteComponent(() => import("./index")),
    validateSearch: (search: JobDescriptionsSearch) => {
        return JobDescriptionsSearchSchema.parse(search);
    },
    beforeLoad: async () => {
        const allowedAdminAndUser = await allowAdminAndUser();
        if (allowedAdminAndUser) {
            requireScope("accountOrNetwork");
        }
        // Prefetch legal values to cache for use in JobDescriptionPanel
        await queryClient.prefetchQuery(queries.legalValues.list());

        return { getTitle: () => i18n.doc_title_job_descriptions() };
    },
});
